import { render, staticRenderFns } from "./Page06.vue?vue&type=template&id=0650cee8&scoped=true&"
import script from "./Page06.vue?vue&type=script&lang=js&"
export * from "./Page06.vue?vue&type=script&lang=js&"
import style0 from "./Page06.vue?vue&type=style&index=0&id=0650cee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650cee8",
  null
  
)

export default component.exports